<convfact-conceptfamily-form [conceptfamily]="conceptfamily" *ngIf="conceptfamily" [errors]="errors" (onSave)="saveData($event)"></convfact-conceptfamily-form>